import { Box, Tab, Tabs } from '@mui/material';
import { useGameStore } from 'src/store/useGame.store';

interface MainTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

export const MainTabs = ({ value, onChange }: MainTabsProps) => {
  const defaultTabs = ['General Settings', 'Rounds', 'Leaderboard'];

  const { isPrivateCompetition } = useGameStore();

  const tabs = isPrivateCompetition
    ? [...defaultTabs, 'Participants']
    : defaultTabs;

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={value}
        onChange={onChange}
        aria-label='basic tabs example'
        variant='scrollable'
        scrollButtons='auto'
      >
        {tabs.map((tab, index) => (
          <Tab key={tab} label={tab} {...a11yProps(index)} />
        ))}
      </Tabs>
    </Box>
  );
};
